export class GlobalID {
  model: string;
  id: number;

  constructor({ model, id }) {
    this.model = model;
    this.id = id;
  }

  static decode(gid: string, options: { interfaceType: string[] } = { interfaceType: null }) {
    const [rawId, defaultType] = atob(gid).split('/').reverse();
    const model = GlobalID.getTypename(options.interfaceType, defaultType);
    const id = parseInt(rawId, 10);

    return new GlobalID({ model, id });
  }

  toString() {
    const appName = 'sentry';
    return btoa(`gid://${appName}/${this.model}/${this.id}`);
  }

  toApolloCacheKey() {
    return `${this.model}:${this.id}`;
  }

  private static getTypename(interfaceType: string[], defaultType: string): string {
    if (interfaceType && interfaceType[0] === defaultType) {
      return interfaceType[1];
    }
    return defaultType;
  }
}
